import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class AllClasses extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='AllClasses'>
      <h3>Dojo's Names</h3>
      <br />
      <br />

        <div><Link to='/classesrenbukan'>1.Renbukan Dojo</Link></div>

        <br />

        <div><Link to='/classestuksomrangsit'>2.Aikido Tuksom Rangsit</Link></div>

        <br />

        <div><Link to='/classestuksomromkaow'>3.Aikido Tuksom Romkaow</Link></div>

        <br />

        <div><Link to='/classesbmz'>4.BMZ Dojo</Link></div>

        <br />

        <div><Link to='/classessattahip'>5.Marines Martial Arts Sattahip</Link></div>

        <br />

        <div><Link to='/classeschula'>6.Chulalongkorn University Aikido Club</Link></div>

        <br />

        <div><Link to='/classeswongwianyai'>7.Aikido Wongwian Yai Dojo</Link></div>

        <br />

        <div><Link to='/classeschiangmai'>8.Aikido Chiang Mai Dojo</Link></div>

        <br />

        <div><Link to='/classeskorat'>9.Aikido Korat Dojo</Link></div>

        <br />

        <div><Link to='/classesfudokan'>10.Fudokan Soul Studio</Link></div>

        <br />

        <div><Link to='/classeslumpini'>11.Marine Martial Arts Lumpini</Link></div>

        <br />

        <div><Link to='/classesmasakatsu'>12.Masakatsu Renbukan Dojo</Link></div>

        <br />
        <div>
          Thailand's Aikido Association Registration and Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default AllClasses;
